function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_1739",
  "data-name": "\\uADF8\\uB8F9 1739",
  transform: "translate(-921 -609.986)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_482",
  "data-name": "\\uD328\\uC2A4 482",
  d: "M3,10.978,14.543,2l11.543,8.978V25.086a2.565,2.565,0,0,1-2.565,2.565H5.565A2.565,2.565,0,0,1,3,25.086Z",
  transform: "translate(918 607.986)",
  fill: "#777"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_483",
  "data-name": "\\uD328\\uC2A4 483",
  d: "M14.054,23.268V12H9V23.268Z",
  transform: "translate(921.017 613.557)",
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgArtistHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.086,
    height: 27.838,
    viewBox: "0 0 23.086 27.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistHome);
export default __webpack_public_path__ + "static/media/artist-home.6fa3f223.svg";
export { ForwardRef as ReactComponent };